<label class="im:floating-label">
  @if (label()) {
    <span floatingLabel>{{ label() | translate }}</span>
  }
  <input
    class="im:input"
    #d="ngbDatepicker"
    ngbDatepicker
    [positionTarget]="icon"
    [formControl]="ngControl.control"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
    [placeholder]="label() | translate"
    [attr.aria-labelledby]="ariaLabelledby()"
  />
  <div #icon class="trailing-icon" (click)="$event.preventDefault()">
    <rs-web-icon [icon]="ImmomioIconName.Calendar" (tapped)="d.toggle()"></rs-web-icon>
  </div>
</label>
